import { render, staticRenderFns } from "./PostList.vue?vue&type=template&id=544f9056&scoped=true&"
import script from "./PostList.vue?vue&type=script&lang=js&"
export * from "./PostList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "544f9056",
  null
  
)

export default component.exports